const forms = require('../ui/forms');
const template = require('./card-tactic.tpl').default;

module.exports = DomClass(template, function CardTactic() {
	var _t = this;

	this.selected = this.selected || false;
	this.selector.checked = this.selected;
	forms.attachLabel(this.selector, this.label, 'cardTactic');

	this.lock = function() {
		this.classList.add('locked');
		this.selector.disabled = true;
	};

	this.unlock = function() {
		this.classList.remove('locked');
		this.selector.disabled = false;
	};

	this.selector.onchange = function() {
		_t.selected = _t.selector.checked;
		on(_t, 'change').fire(_t);
	}

});
